(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-zarineh-premium"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAZP() {
    var root = document.querySelector('[data-azp]');
    if (!root || root.dataset.azpInited === '1') return;
    root.dataset.azpInited = '1';

    var reveals = root.querySelectorAll('[data-azp-reveal]');
    if (reveals.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    var counters = root.querySelectorAll('[data-counter]');
    if (counters.length && 'IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var target = parseInt(el.dataset.counter, 10) || 0;
          var duration = 1800;
          var startVal = 0;
          if (target >= 1900 && target <= 2100) {
            startVal = target - 25;
          }
          var start = performance.now();
          (function tick(now) {
            var p = Math.min((now - start) / duration, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            var current = Math.floor(startVal + (target - startVal) * eased);
            el.textContent = current;
            if (p < 1) requestAnimationFrame(tick);
            else el.textContent = target;
          })(start);
          cio.unobserve(el);
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
    } else {
      counters.forEach(function (el) {
        el.textContent = el.dataset.counter;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAZP);
  } else {
    initAZP();
  }

  document.addEventListener('shopify:section:load', initAZP);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-scroll-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVSS(root) {
    if (root.dataset.vssInited === '1') return;
    root.dataset.vssInited = '1';

    var slides = root.querySelectorAll('[data-vss-slide]');
    var dots = root.querySelectorAll('[data-vss-dot]');
    var count = slides.length;
    if (count < 2) return;

    var currentIndex = 0;
    var mq = window.matchMedia('(max-width: 767.98px)');
    var attached = false;
    var rafId = null;

    function setActive(index) {
      if (index === currentIndex) return;
      currentIndex = index;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === index);
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === index);
      }
    }

    function onScroll() {
      var rect = root.getBoundingClientRect();
      var wrapperHeight = root.offsetHeight;
      var viewportHeight = window.innerHeight;
      var scrollable = wrapperHeight - viewportHeight;
      if (scrollable <= 0) return;

      var scrolled = -rect.top;
      if (scrolled < 0) scrolled = 0;
      if (scrolled > scrollable) scrolled = scrollable;

      var progress = scrolled / scrollable;
      var raw = progress * count;
      var index = Math.min(count - 1, Math.floor(raw));
      setActive(index);
    }

    function scheduleScroll() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        onScroll();
      });
    }

    function attach() {
      if (attached || mq.matches) return;
      attached = true;
      window.addEventListener('scroll', scheduleScroll, { passive: true });
      onScroll();
    }

    function detach() {
      if (!attached) return;
      attached = false;
      window.removeEventListener('scroll', scheduleScroll);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          attach();
        } else {
          detach();
        }
      });
    }, { rootMargin: '200px 0px 200px 0px' });
    io.observe(root);

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (mq.matches) return;
        var wrapperTop = root.getBoundingClientRect().top + window.pageYOffset;
        var wrapperHeight = root.offsetHeight;
        var viewportHeight = window.innerHeight;
        var scrollable = wrapperHeight - viewportHeight;
        var target = wrapperTop + ((i + 0.4) / count) * scrollable;
        window.scrollTo({ top: target, behavior: 'smooth' });
      });
    });

    function handleMQ() {
      if (mq.matches) {
        detach();
      } else {
        attach();
      }
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', handleMQ);
    } else if (mq.addListener) {
      mq.addListener(handleMQ);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-vss]').forEach(initVSS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target.querySelector ? e.target.querySelector('[data-vss]') : null;
    if (target) initVSS(target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
